import {Injectable} from '@angular/core';
import {LocalStorageService} from 'ngx-webstorage';

@Injectable()
export class TokenService {

  constructor(private storage: LocalStorageService) {
  }

  setTokens(tokens) {
    this.storage.store('tokens', tokens);
  }

  getTokens() {
    return this.storage.retrieve('tokens');
  }

  removeTokens() {
    this.storage.clear('tokens');
  }

  getAccessToken() {
    const tokens = this.storage.retrieve('tokens');
    if (tokens && tokens.AccessToken) {
      return tokens.AccessToken;
    } else {
      return null;
    }
  }

  getRefreshToken() {
    const tokens = this.storage.retrieve('tokens');
    if (tokens && tokens.RefreshToken) {
      return tokens.RefreshToken;
    } else {
      return null;
    }
  }

  getFileServiceToken() {
    const tokens = this.storage.retrieve('tokens');
    if (tokens && tokens.EcoSystemAccessToken) {
      return tokens.EcoSystemAccessToken;
    } else {
      return null;
    }
  }

  getKeepMeLoggedIn() {
    const tokens = this.storage.retrieve('tokens');
    if (tokens && tokens.keepMeLoggedIn) {
      return tokens.keepMeLoggedIn;
    } else {
      return null;
    }
  }

}
